export function formatNumber(
  value: number | string,
  options?: Intl.NumberFormatOptions,
  locales: Intl.LocalesArgument = 'en-US'
) {
  const value_ = Number(value);
  return isNaN(value_)
    ? '-'
    : value_.toLocaleString(locales, { minimumFractionDigits: 2, ...options });
}

export function isNumber(value: any) {
  return !isNaN(Number(value));
}

export function genId() {
  const timestampPart = Date.now().toString(36);
  const randomPart = Math.random().toString(36).slice(2, 9);
  return timestampPart + randomPart;
}
